export enum Path {
  // Admin
  Admin = "/admin",
  AdminUserManagement = "/admin/user-management",
  AdminUser = "/admin/user-management/:userId",
  AdminUserProfile = "/admin/user-management/:userId/profile",
  AdminUserProjects = "/admin/user-management/:userId/projects",
  AdminAddNewUser = "/admin/user-management/add-user",
  AdminTenants = "/admin/tenants",
  AdminFeatureFlags = "/admin/feature-flags",

  // ----
  HomePage = "/",
  LegalAcknowledgementsConsent = "/legal-acknowledgements",
  LegalAcknowledgementDecline = "/legal-acknowledgements/do-not-agree",
  Login = "/login",
  Registration = "/registration",
  RegistrationConfirmation = "/registration/confirmation",
  Profile = "/profile",

  // Project
  Projects = "/projects",
  Project = "/projects/:projectId",
  ProjectSummary = "/projects/:projectId/summary",
  ProjectTasks = "/projects/:projectId/tasks",
  ProjectDocuments = "/projects/:projectId/documents",
  ProjectDocument = "/projects/:projectId/documents/:documentId",
  ProjectHAQs = "/projects/:projectId/HA-questions",
  ProjectHAQ = "/projects/:projectId/HA-questions/:HAQId",
  ProjectParticipatingHAs = "/projects/:projectId/participating-HAs",
  ProjectDetails = "/projects/:projectId/details",
  ProjectMembers = "/projects/:projectId/members",
  ProjectECTD = "/projects/:projectId/documents/ECTD/:ECTDId",
  ProjectMilestones = "/projects/:projectId/milestones",
  ProjectStructuredDocument = "/projects/:projectId/documents/structured-document/:structuredDocumentId",
  ProjectStructuredDocumentManagement = "/projects/:projectId/documents/structured-document/:structuredDocumentId/management",
  // eslint-disable-next-line max-len
  ProjectStructuredDocumentManagementOrdering = "/projects/:projectId/documents/structured-document/:structuredDocumentId/management/ordering",

  // Tasks
  Tasks = "/tasks",
  Task = "/tasks/:taskGroupId",

  NotFound = "/not-found",
}

// currently we use it only as workaround to have ability use Route component inside of React components
// TODO: refactor breadcrumbs & tabs components logic to have ability fully migrate
// to relative paths
export enum RelativePath {
  // Project
  Project = "projects/:projectId/*",
  ProjectSummary = "summary",
  ProjectMilestones = "milestones",
  ProjectTasks = "tasks",
  ProjectDocuments = "documents",
  ProjectHAQs = "HA-questions",
  ProjectParticipatingHAs = "participating-HAs",
  ProjectDetails = "details",
  ProjectMembers = "members",
  ProjectECTD = "documents/ECTD/:ECTDid",
}

export const APPLICATION_ROUTES = [
  {
    path: Path.Projects,
    name: "projects",
  },
  {
    path: Path.Project,
  },
  {
    path: Path.ProjectSummary,
    name: "summary",
  },
  {
    path: Path.ProjectTasks,
    name: "tasks",
  },
  {
    path: Path.ProjectDocuments,
    name: "documents",
  },
  {
    path: Path.ProjectDocument,
  },
  {
    path: Path.ProjectHAQs,
    name: "Questions",
  },
  {
    path: Path.ProjectHAQ,
  },
  {
    path: Path.ProjectParticipatingHAs,
    name: "participatingHAs",
  },
  {
    path: Path.ProjectMembers,
    name: "members",
  },
  {
    path: Path.Admin,
    name: "admin",
  },
  {
    path: Path.AdminUserManagement,
    name: "userManagement",
  },
  {
    path: Path.ProjectECTD,
  },
];
